<template>
  <div class="flex">
    <userAvatar :src="props.data.avatar || ''" class="mr-10" />
    <div class="flex-1">
      <div class="flex-s">
        <span class="show1Row">{{ props.data.nickName }}</span>
        <span class="tag" v-if="props.data.roleCode === 'TEAM_CREATE'">归属者</span>
      </div>
      <div class="show1Row">{{ props.data.mobile || '' }}</div>
    </div>
  </div>
</template>

<script setup>
import userAvatar from '@/components/userAvatar.vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  tag: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="less" scoped>
.tag {
  background: linear-gradient(270deg, #ffdab0 0%, #ffeed4 100%);
  color: #754417;
  font-size: 0.6em;
  padding: 0.2em 0.4em;
  border-radius: 4px;
  margin-left: 4px;
  word-break: keep-all;
}
</style>
